
/**
 * 促销铭牌（促销铭牌一期 / 2026-09-18 统一整改）
 *
 * 商品名称下方的轻量信息行，最多 2 枚，只显示进行中活动的名称（promotions.name）：
 *   主活动 1 枚；多活动时至多补第 2 枚活动名——组件与卡片层都不解析促销规则
 *   （买N送M/满减文案只在促销详情/商品详情/订单确认展示）。
 * 真相源是 promotions/product_promotions，后端按 status+时间窗判定后注入
 * p.promotion_badges —— 组件只渲染，不自行推断（不从价格差推导文案，也不判活动是否生效）。
 *
 * 行高固定 18px：无活动商品渲染空行占位，保证有/无活动卡片等高，
 * 瀑布流/网格不因铭牌出现而参差。不与 tier 徽标抢图片区。
 */
export default {
  name: 'PromoBadges',
  props: {
    // 后端注入的 p.promotion_badges = ['秋季采购节'] | ['秋季采购节', '双十一返场'] | []
    badges: { type: Array, default: () => [] }
  },
  computed: {
    list () {
      return (this.badges || []).filter(Boolean).slice(0, 2)
    }
  }
}
